<template v-if="userdata">
  <div class="fl-sym-px-4">
    <div class="fl-sym-mt-20 fl-sym-letter-space-08 fl-sym-text-dark-blue fl-sym-text-xxs regular">
      CREATE ACCOUNT
    </div>
    <div
        class="fl-sym-text-black fl-sym-text-5xl fl-sym-leading-tight fl-sym-font-bold fl-sym-mb-2 fl-sym-letter-space-minus-02"
    >
      Tell us about you
    </div>
    <div class="fl-sym-text-intermediat fl-sym-text-lg fl-sym-text-intermediate">
      You can update your details anytime.
    </div>
    <form class="fl-sym-mt-20 xnpms:fl-sym-mt-16 " @submit.prevent="submit">
      <div class="form-group fl-sym-border fl-sym-px-3 fl-sym-py-1 fl-sym-border-graduate fl-sym-rounded ">
        <label for="first_name">Name</label>
        <input
            placeholder="Name"
            v-model="userdata.first_name"
            name="user.first_name"
            id="first_name"
            requiredm
            class="fl-sym-w-full  fl-sym-text-lg  fl-sym-mb-1 focus:fl-sym-outline-none focus:fl-sym-border-secondary fl-sym-placeholder-graduate"
        />
        <div v-if="errors">
          <div class="fl-sym-text-red-600 fl-sym-mt-1 fl-sym-ml-3 fl-sym-mt-1"
               v-if="errors.first_name">
            <font-awesome-icon icon="exclamation-circle"></font-awesome-icon>
            {{ errors.first_name }}
          </div>
        </div>
      </div>
      <div class="form-group fl-sym-border fl-sym-border-graduate fl-sym-rounded fl-sym-px-3 fl-sym-py-1 fl-sym-mt-8">
        <label for="last_name">Surname</label>
        <input
            placeholder="Surname"
            id="last_name"
            required
            name="last_name"
            v-model="userdata.last_name"
            class="fl-sym-w-full  fl-sym-text-lg fl-sym-mb-1 focus:fl-sym-outline-none focus:fl-sym-border-secondary fl-sym-placeholder-graduate"
        />
        <div v-if="errors">
          <div class="fl-sym-text-red-600 fl-sym-mt-1 fl-sym-ml-3 fl-sym-mt-1" v-if="errors.last_name">
            <font-awesome-icon icon="exclamation-circle"></font-awesome-icon>
            {{ errors.last_name }}
          </div>
        </div>
      </div>

      <div class="fl-sym-mt-20 fl-sym-mb-2">
        <button
            type="submit"
            class="fl-sym-bg-primary fl-sym-rounded-full fl-sym-text-white fl-sym-p-3 fl-sym-w-full fl-sym-text-sm hover:fl-sym-border-primary fl-sym-transition-all fl-sym-transition fl-sym-duration-300 fl-sym-ease-out email-password"
        >
          <span class="fl-sym-text-primary fl-sym-font-bold">
            Email & password
          </span>
          <img src="@/assets/chevron-right-thin.svg" width="8" class="chevron-left-thin-button fl-sym-ml-13 fl-sym-float-right fl-sym-text-primary fl-sym-font-bold">
        </button>

        <button
            class="fl-sym-mt-4 fl-sym-bg-primary fl-sym-font-bold fl-sym-rounded-full fl-sym-text-white fl-sym-p-3 fl-sym-w-full fl-sym-text-sm already-account">
          <router-link class="link" :to="{name: login_route }">I already have an account</router-link>
        </button>
      </div>
      <div class="fl-sym-flex fl-sym-justify-center fl-sym-text-sm fl-sym-mt-4">
        <div class="fl-sym-text-primary fl-sym-font-semibold hover:fl-sym-text-opacity-75" style="cursor: pointer" @click="back">
          Back
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import {mapState} from "vuex";

export default {
  data() {
    return {
      login_route: process.env.VUE_APP_AUTH_LOGIN,
      userdata: {
        first_name: '',
        last_name: ''
      },
    }
  },
  computed: {
    ...mapState({
      //user: state => state.auth.user,
      session_id: (state) => state.register.session_id,
      errors: state => state.auth.errors
    }),
  },
  methods: {
    back() {
      this.$router.go("-1");
    },
    submit() {
      this.$store.dispatch('auth/register_step_1', this.userdata)
    },
  },
};
</script>
<style>
.error {
  top: 460px;
  left: 20px;
  width: 366px;
  height: 16px;
  letter-spacing: var(--unnamed-character-spacing-0);
  text-align: left;
  letter-spacing: 0px;
  opacity: 1;
  font: "SFProDisplay-Regular";
  font-size: 16px;
  color: #ff3a19;
}

.border-red {
  border-color: #ff3a19;
}

.email-password {
  background-color: white;
  color: black;
  border: 2px solid #707070;
}

.back {
  font-family: "SFProDisplay-Semibold";
}

.already-account {
  color: var(--unnamed-color-6f7878);
  text-align: center;
  letter-spacing: 0.64px;
  color: #6f7878;
  background-color: #d0dada;
  opacity: 0.6;
}

.already-account:hover {
  color: black;
}

.email-password-text {
  color: var(--progress-bar-filler);
  text-align: center;
  letter-spacing: 0.64px;
  color: #00c5e3;
  opacity: 1;
}

.heading {
  letter-spacing: var(--unnamed-character-spacing--0-2);
  color: var(--unnamed-color-000000);
  text-align: left;
  letter-spacing: -0.2px;
  color: #000000;
  font-weight: bold;
  opacity: 1;
}

.update-text {
  font: var(--unnamed-font-style-normal) normal var(--unnamed-font-weight-normal) var(--unnamed-font-size-17) /
    var(--unnamed-line-spacing-22) var(--unnamed-font-family-sf-pro-display);
  letter-spacing: var(--unnamed-character-spacing-0-56);
  color: var(--unnamed-color-6f7878);
  text-align: left;
  font: normal normal normal 17px/22px SF Pro Display;
  letter-spacing: 0.56px;
  color: #6f7878;
  opacity: 1;
}
label {
    text-align: left;
    color: #6F7878;
    font-size: 12px;
    letter-spacing: 0.4px;
    line-height: 22px;
}
</style>
